import { GACustom } from './types';
import { AvailableService, AvailableStore } from '../Appointment/model';
import { getLocationTypeGA, ServiceLocation } from '../../helpers';
import { getStore } from '../../helpers/storeHelper';
import { getService } from '../../helpers/serviceHelper';

export interface CustomParamsForGAEvent {
  postalCode: string;
  step: string;
  options?: {
    userIsLoggedIn?: boolean;
    serviceId?: string;
    services?: AvailableService[];
    storeId?: string;
    stores?: AvailableStore[];
  };
}

const transformCustomPartGA = (
  currency: string,
  locationType: ServiceLocation,
): {
  location_type: string;
  currency: string;
} => {
  return {
    location_type: getLocationTypeGA(locationType),
    currency,
  };
};

const transformServiceParamsGA = (
  serviceId: string,
  serviceCode: string,
  price: number,
): {
  id: string;
  name: string;
  price: number;
} => {
  return {
    id: serviceCode,
    name: serviceId,
    price,
  };
};

const transformStoreParamsGA = (storeName: string): { store_name?: string } => {
  return storeName.length > 0 ? { store_name: storeName } : {};
};

export const transformToGACustomPayload = ({
  postalCode,
  step,
  options,
}: CustomParamsForGAEvent): GACustom => {
  const { serviceId, services, storeId, stores, userIsLoggedIn } =
    options || {};

  const service = serviceId && getService(serviceId, services);

  if (!service) {
    return {
      custom: {
        postal_code: postalCode,
        step,
      },
    };
  }

  const {
    currencyCode,
    price,
    familyPrice,
    serviceCode,
    location: locationType,
  } = service;

  const storeName =
    storeId && storeId !== 'default'
      ? getStore(storeId, stores)?.text || ''
      : '';

  return {
    custom: {
      postal_code: postalCode,
      step,
      ...transformCustomPartGA(currencyCode, locationType),
      ...transformStoreParamsGA(storeName),
    },
    params: {
      items: [
        {
          quantity: 1,
          ...transformServiceParamsGA(
            serviceId,
            serviceCode,
            userIsLoggedIn ? familyPrice : price,
          ),
        },
      ],
    },
  };
};
